<router-outlet></router-outlet>
<ngx-spinner
  type="ball-clip-rotate"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#4e73df"
></ngx-spinner>
